<template>
  <div>
    <PageHeader title="Contact"></PageHeader>
    <v-card
      outlined
      class="vcardcontent"
       v-bind:class="{ 'version-spacing': !isLoggedIn }"
    >
      <v-card-text style="color:#ffffff;" class="honeyBold">
        <p>Want to get in touch with the team at fanhive? We are always happy to help.</p>
        <p>Drop us an email anytime using the email listed below.</p>
        <p><a mailto="support@fanhive.co.uk">support@fanhive.co.uk</a></p>
        <p>We aim to get a response out within 24 hours.</p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';

export default {
  name: 'contact',
  components: {
    PageHeader
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    },
  },
  created () {
    
  }
}
</script>